/* @ngInject */
const ask = (
  contactRequest,
  contactData,
  contactLocal,
  contactFormat,
  emailRequest,
  phoneRequest,
  labels,
  utils,
  toaster
) => {
  const self = {}

  self.delete = async (_id, _back = false) => {
    if (toaster.confirm(labels.contact.ask.delete)) {
      try {
        const message = await contactRequest.delete(_id)
        toaster.message(message)
        utils.removeFromArray(contactData.myContacts, _id)
        if (_back) { utils.$back() }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  self.deleteEmail = async (_id, _contactIndex, _back = false) => {
    if (toaster.confirm(labels.email.ask.delete)) {
      try {
        const message = await emailRequest.delete(_id)
        toaster.message(message)
        utils.removeFromArray(contactData.myContacts[_contactIndex].emails, _id)
        if (_back) { utils.$back() }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  self.deletePhone = async (_id, _contactIndex, _back = false) => {
    if (toaster.confirm(labels.phones.ask.delete)) {
      try {
        const message = await phoneRequest.delete(_id)
        toaster.message(message)
        utils.removeFromArray(contactData.myContacts[_contactIndex].phones, _id)
        if (_back) { utils.$back() }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  self.update = async (_contact, _back = false) => {
    try {
      let contact = utils.copy(_contact)
      contact.id = contactLocal.getCurrentId()
      contact = contactFormat.server(contact)

      const response = await contactRequest.update(contact)
      toaster.message(response.message)
      utils.updateFromArray(contactData.myContacts, response.contact)
      if (_back) {
        utils.$back()
      }
    } catch (error) {
      toaster.error(error)
    }
  }

  return self
}

export default ask



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/services/ask.service.js